import { createSlice } from "@reduxjs/toolkit";

export const loadingSurveySlice = createSlice({
  name: "loadingSurvey",
  initialState: false,
  reducers: {
    setLoadingSurvey: (state, action) => {
      return action.payload;
    },
  },
});

export const { setLoadingSurvey } = loadingSurveySlice.actions;

export default loadingSurveySlice.reducer;
